export const Features = {
  SentryEnabled: 'VITE_APP_SENTRY_ENABLED',
  ReportingV2: 'VITE_APP_REPORTING_V2',
  ReportFilters: 'VITE_APP_SHOW_REPORT_FILTERS',
  EventWizardNatterSettings: 'VITE_APP_EVENT_WIZARD_NATTER_SETTINGS',
  AutomatedGeneratedReports: 'VITE_APP_AUTOMATED_GENERATED_REPORTS',
  BackstageV2: 'VITE_APP_ENABLE_BACKSTAGE_V2',
  IntercomEnabled: 'VITE_APP_ENABLE_INTERCOM',
  DatadogEnabled: 'DATADOG_ENABLED',
  DatadogProxyEnabled: 'DATADOG_PROXY_ENABLED',
  EnablePasswordlessMagicLinks: 'VITE_APP_ENABLE_PASSWORDLESS_MAGIC_LINKS',
  EnablePasswordlessOtp: 'VITE_APP_ENABLE_PASSWORDLESS_OTP',
  AgoraScreenShareV2: 'VITE_APP_AGORA_SCREENSHARE_V2',
  NatteringDisconnectOverlay: 'VITE_APP_NATTERING_DISCONNECT_OVERLAY',
  AblyTechCheckProbe: 'VITE_APP_ABLY_TECH_CHECK_PROBE',
  LiveCaptions: 'VITE_APP_LIVE_CAPTIONS',
  NatalieReporting: 'VITE_APP_NATALIE_REPORTING',
  CustomVideoBackground: 'VITE_APP_CUSTOM_VIDEO_BACKGROUND',
} as const;
